import * as RadixDialog from '@radix-ui/react-dialog';
import { ReactNode, Ref } from 'react';

type DialogProps = RadixDialog.DialogProps & {
  children: ReactNode;
  ref?: Ref<HTMLDivElement>;
};

const Dialog = ({ children, ...props }: DialogProps) => (
  <RadixDialog.Root {...props}>{children}</RadixDialog.Root>
);

export { Dialog, type DialogProps };
